module.exports = __webpack_public_path__ + "img/hexin4.4504d8f1.png";